export const workflowtableheading = [
  "",
  "Sr.#",
  "Rule Name",
  "Conditions",
  "Type",
  "Accounts",
  "Category",
  "Actions",
];

export const workflowtabledata = [
  {
    workstatus: " ",
    id: "01",
    workflowname: "Category Rule No.1",
    rules: "The Amount equal 1",
    percentage: "Cash Inflow",
    description: "All Accounts",
    category:'Uncategorized',
    action: "",
  },
  {
    workstatus: " ",
    id: "02",
    workflowname: "Category Rule No.1",
    rules: "The Amount equal 1",
    percentage: "Cash Inflow",
    description: "All Accounts",
    category:'Uncategorized',
    action: "",
  },
  {
    workstatus: " ",
    id: "03",
    workflowname: "Category Rule No.1",
    rules: "The Amount equal 1",
    percentage: "Cash Inflow",
    description: "All Accounts",
    category:'Uncategorized',
    action: "",
  },
  {
    workstatus: " ",
    id: "04",
    workflowname: "Category Rule No.1",
    rules: "The Amount equal 1",
    percentage: "Cash Inflow",
    description: "All Accounts",
    category:'Uncategorized',
    action: "",
  },
  {
    workstatus: " ",
    id: "05",
    workflowname: "Category Rule No.1",
    rules: "The Amount equal 1",
    percentage: "Cash Inflow",
    description: "All Accounts",
    category:'Uncategorized',
    action: "",
  },
  {
    workstatus: " ",
    id: "06",
    workflowname: "Category Rule No.1",
    rules: "The Amount equal 1",
    percentage: "Cash Inflow",
    description: "All Accounts",
    category:'Uncategorized',
    action: "",
  },
  {
    workstatus: " ",
    id: "07",
    workflowname: "Category Rule No.1",
    rules: "The Amount equal 1",
    percentage: "Cash Inflow",
    description: "All Accounts",
    category:'Uncategorized',
    action: "",
  },
];
